"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _react = _interopRequireDefault(require("react")),
  _ValidationMessage = _interopRequireDefault(require("../../FormElements/ValidationMessage")),
  _default = exports["default"] = function (a) {
    var b = a.defaultProps,
      c = b.field,
      d = b.validationMessage,
      e = b.touched,
      f = b.setTouched,
      g = b.updateForm,
      h = b.formattedInputs,
      i = b.error,
      j = b.unsetError,
      k = b.setFocusClass,
      l = b.styledComponents,
      m = c.id,
      n = c.formId,
      o = c.type,
      p = c.customName,
      q = (l || !1).Input,
      r = void 0 === q ? "input" : q;
    return _react["default"].createElement(_react["default"].Fragment, null, h && h.map(function (a, b) {
      return _react["default"].createElement("div", {
        className: o,
        key: a.id
      }, _react["default"].createElement(r, {
        id: "input_".concat(n, "_").concat(m, "_").concat(b),
        type: "number",
        name: p || "input_".concat(m, "[]"),
        placeholder: a.placeholder,
        step: "1",
        min: "1",
        max: "MM" === a.label ? 12 : "DD" === a.label ? 31 : new Date().getFullYear() + 1,
        maxLength: "YYYY" === a.label ? 4 : 2,
        value: a.value,
        onBlur: function onBlur(d) {
          c.subId = b, c.dateLabel = a.label, g(d, c), f(m), j(m), k("" !== a.value);
        },
        onFocus: function onFocus() {
          return k(!0);
        }
      }), _react["default"].createElement("label", {
        htmlFor: "input_".concat(n, "_").concat(m, "_").concat(b),
        className: "hide-label"
      }, a.label), d && e && d[b] && b === d[b].index && d[b].message && _react["default"].createElement("span", {
        className: "error-message",
        id: "error_".concat(n, "_").concat(a.id)
      }, d[b].message), i && _react["default"].createElement("span", {
        className: "error-message"
      }, i));
    }));
  };